import TextButton from 'components/inputs/TextButton';
import styled from 'styled-components';

export const LabelList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const LabelTextButton = styled(TextButton)`
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 5px;
  padding: 5px;
  margin: 0px !important;
  // tint border on hover
  gap: 5px;
  display: flex;
  align-items: center;
  &:hover {
    border-color: ${({ theme }) => theme.colors.foreground.tint};
  }
`;
